/** @format */

import React from "react";
import "../SCSS/styles.scss";
import Intro from "./Intro";
import Subscribe from "./Subscribe";
import Posts from "./Posts";
import MetaTags from "react-meta-tags";
import NewsletterThirtyOne from "../NewsletterThirtyOne";
import NewsletterThirty from "../NewsletterThirty";
import NewsletterTwentyNine from "../NewsletterTwentyNine";
import NewsletterTwentyEight from "../NewsletterTwentyEight";
import NewsletterTwentySeven from "../NewsletterTwentySeven";
import NewsletterTwentySix from "../NewsletterTwentySix";
import NewsletterTwentyFive from "../NewsletterTwentyFive";
import NewsletterTwentyFour from "../NewsletterTwentyFour";
import NewsletterTwentyThree from "../NewsletterTwentyThree";
import NewsletterTwentyTwo from "../NewsletterTwentyTwo";
import NewsletterTwentyOne from "../NewsletterTwentyOne";
import NewsletterTwenty from "../NewsletterTwenty";
import NewsletterNineteen from "../NewsletterNineteen";
import NewsletterEighteen from "../NewsletterEighteen";
import NewsletterSeventeen from "../NewsletterSeventeen";
import NewsletterSixteen from "../NewsletterSixteen";
import NewsletterFifteen from "../NewsletterFifteen";
import NewsletterFourteen from "../NewsletterFourteen";
import NewsletterThirteen from "../NewsletterThirteen";
import NewsletterEleven from "../NewsletterEleven";
import NewsletterTwelve from "../NewsletterTwelve";
import NewsletterTen from "../NewsletterTen";
import NewsletterNine from "../NewsletterNine";
import NewsletterEight from "../NewsletterEight";
import NewsletterSeven from "../NewsletterSeven";
import NewsletterSix from "../NewsletterSix";
import NewsletterFive from "../NewsletterFive";
import NewsletterFour from "../NewsletterFour";
import NewsletterThree from "../NewsletterThree";
import NewsletterTwo from "../NewsletterTwo";
import NewsletterOne from "../NewsletterOne";
import NewsletterThirtyTwo from "../NewsletterThirtyTwo";
import NewsletterThirtyThree from "../NewsletterThirtyThree";
import NewsletterThirtyFour from "../NewsletterThirtyFour";
import Newsletter_35 from "../Newsletter_35";
import Newsletter_36 from "../Newsletter_36";
import Newsletter_37 from "../Newsletter_37";
import Newsletter_38 from "../Newsletter_38";
import Newsletter_39 from "../Newsletter_39";
import Newsletter_40 from "../Newsletter_40";
import Newsletter_41 from "../Newsletter_41";
import Newsletter_42 from "../Newsletter_42";
import Newsletter_43 from "../Newsletter_43";
import Newsletter_44 from "../Newsletter_44";
import Newsletter_45 from "../Newsletter_45";
import Newsletter_46 from "../Newsletter_46";
import Newsletter_47 from "../Newsletter_47";
import Newsletter_48 from "../Newsletter_48";
import Newsletter_49 from "../Newsletter_49";
import Newsletter_50 from "../Newsletter_50";

function Newsletter({ newslettersData, handleClick, month, year }) {
  const newsletterHash = {
    "november 2026": <Newsletter_50 />,
    "october 2026": <Newsletter_49 />,
    "september 2026": <Newsletter_48 />,
    "august 2026": <Newsletter_47 />,
    "july 2026": <Newsletter_46 />,
    "june 2026": <Newsletter_45 />,
    "may 2026": <Newsletter_44 />,
    "april 2026": <Newsletter_43 />,
    "march 2026": <Newsletter_42 />,
    "february 2026": <Newsletter_41 />,
    "january 2026": <Newsletter_40 />,
    "december 2025": <Newsletter_39 />,
    "november 2025": <Newsletter_38 />,
    "october 2025": <Newsletter_37 />,
    "september 2025": <Newsletter_36 />,
    "august 2025": <Newsletter_35 />,
    "july 2025": <NewsletterThirtyFour />,
    "june 2025": <NewsletterThirtyThree />,
    "may 2025": <NewsletterThirtyTwo />,
    "april 2025": <NewsletterThirtyOne />,
    "march 2025": <NewsletterThirty />,
    "february 2025": <NewsletterTwentyNine />,
    "january 2025": <NewsletterTwentyEight />,
    "december 2024": <NewsletterTwentySeven />,
    "november 2024": <NewsletterTwentySix />,
    "october 2024": <NewsletterTwentyFive />,
    "september 2024": <NewsletterTwentyFour />,
    "august 2024": <NewsletterTwentyThree />,
    "july 2024": <NewsletterTwentyTwo />,
    "june 2024": <NewsletterTwentyOne />,
    "may 2024": <NewsletterTwenty />,
    "april 2024": <NewsletterNineteen />,
    "march 2024": <NewsletterEighteen />,
    "february 2024": <NewsletterSeventeen />,
    "january 2024": <NewsletterSixteen />,

    "december 2023": <NewsletterFifteen />,
    "november 2023": <NewsletterFourteen />,
    "october 2023": <NewsletterThirteen />,
    "september 2023": <NewsletterTwelve />,
    "august 2023": <NewsletterEleven />,
    "july 2023": <NewsletterTen />,
    "june 2023": <NewsletterNine />,
    "may 2023": <NewsletterEight />,
    "april 2023": <NewsletterSeven />,
    "march 2023": <NewsletterSix />,
    "february 2023": <NewsletterFive />,
    "january 2023": <NewsletterFour />,

    "december 2022": <NewsletterThree />,
    "november 2022": <NewsletterTwo />,
    "october 2022": <NewsletterOne />,
  };
  const newsletterComponent = newsletterHash[`${month} ${year}`] || null;

  return (
    <>
      {!newsletterComponent ? (
        <>
          <MetaTags>
            <title>Newsletter | Updapt</title>
            <meta
              name="description"
              content="Keep up with the latest ESG news and climate change insights."
            />
            <meta property="og:title" content="Newsletter | Updapt" />
            <meta
              property="og:image"
              content="%PUBLIC_URL%/static/media/banner.jpg"
            />
          </MetaTags>

          <Intro />

          <Posts newslettersData={newslettersData} handleClick={handleClick} />
          <Subscribe />
        </>
      ) : (
        <>{newsletterComponent}</>
      )}
    </>
  );
}
export default Newsletter;
